
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ModelSelect } from "@/components/calculadora/equipamento/ModelSelect";

interface OutrosItensFormProps {
  categoriaSelecionada: string;
  setCategoriaSelecionada: (value: string) => void;
  modeloSelecionado: string;
  setModeloSelecionado: (value: string) => void;
  itemPersonalizado: boolean;
  setItemPersonalizado: (value: boolean) => void;
  detalhesEquipamento: any;
  setDetalhesEquipamento: (value: any) => void;
  categoriasOutros: { categoria: string; itens: string[] }[];
  handleAdicionarEquipamento: () => void;
}

export const OutrosItensForm = ({
  categoriaSelecionada,
  setCategoriaSelecionada,
  modeloSelecionado,
  setModeloSelecionado,
  itemPersonalizado,
  setItemPersonalizado,
  detalhesEquipamento,
  setDetalhesEquipamento,
  categoriasOutros,
  handleAdicionarEquipamento
}: OutrosItensFormProps) => {
  return (
    <div>
      <h3 className="font-semibold mb-4">Cadastro de Outros Itens</h3>
      
      <div className="space-y-4">
        <div className="grid gap-2">
          <Label htmlFor="categoria">Categoria</Label>
          <div className="flex gap-2">
            <Input 
              id="categoria" 
              value={categoriaSelecionada}
              onChange={(e) => setCategoriaSelecionada(e.target.value)}
              placeholder="Ex: Estruturas, Cabos, Conectores"
              className="flex-1"
            />
          </div>
        </div>
        
        {categoriaSelecionada && !itemPersonalizado && (
          <ModelSelect 
            modelo={modeloSelecionado}
            setModelo={setModeloSelecionado}
            setPersonalizado={setItemPersonalizado}
            categorias={categoriasOutros}
            categoria={categoriaSelecionada}
            label="Item"
            placeholder="Selecione o item"
          />
        )}
        
        {categoriaSelecionada && itemPersonalizado && (
          <div className="grid gap-2">
            <div className="flex justify-between">
              <Label htmlFor="itemPersonalizado">Item Personalizado</Label>
              <Button 
                type="button" 
                variant="link" 
                className="text-xs h-6 p-0"
                onClick={() => {
                  setItemPersonalizado(false);
                  setModeloSelecionado("");
                }}
              >
                Selecionar Item Existente
              </Button>
            </div>
            <Input 
              id="itemPersonalizado" 
              value={detalhesEquipamento.descricao || ""}
              onChange={(e) => setDetalhesEquipamento({
                ...detalhesEquipamento,
                descricao: e.target.value
              })}
              placeholder="Nome do item"
            />
          </div>
        )}
        
        {categoriaSelecionada && (modeloSelecionado || itemPersonalizado) && (
          <Button 
            onClick={handleAdicionarEquipamento}
            className="w-full mt-4"
          >
            Adicionar Item
          </Button>
        )}
      </div>
    </div>
  );
};
